/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, {useState, useEffect} from "react";
import { Redirect, Switch, Route, useLocation } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {Layout} from "../_metronic/layout";
import BasePage from "./BasePage";
import { Logout, AuthPage } from "./modules/Auth";
import ErrorsPage from "./modules/ErrorsExamples/ErrorsPage";
import PopupNotification from "./modules/PopupNotification";

export function Routes() {
    const {isAuthorized} = useSelector(
        ({auth}) => ({
            isAuthorized: auth.user != null,
        }),
        shallowEqual
    );
    const location = useLocation();
    const [isAuthorizedLocal, setIsAuthorized] = useState(isAuthorized);
    console.log(location);
    // useEffect(() => {
    //     const token = localStorage.getItem('token');
    //     // console.log(token)
    //     if(token) {
    //         setIsAuthorized(true);
    //     }
    // }, []);

    return (
        <Switch>
            {!isAuthorizedLocal ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route>
                    <AuthPage />
                </Route>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from="/auth" to="/"/>
            )}

            <Route path="/error" component={ErrorsPage}/>
            <Route path="/logout" component={Logout}/>


            {!isAuthorizedLocal ? (
               // Redirect to `/auth` when user is not authorized
                <Redirect to="/auth/login"/>
            ) : (
                <Layout>
                    <BasePage/>
                    <PopupNotification/>
                </Layout>
            )}
        </Switch>
    );
}
